import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { motion, useInView } from "framer-motion";
import emailjs from "@emailjs/browser";
import { ReactComponent as ContactSvg } from "../assets/contact.svg";

const Appointment = () => {
  const ref = useRef();
  const formRef = useRef();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [translateY, setTranslateY] = useState(0);
  const [isButtonEnabled, setIsButtonEnabled] = useState(true);

  const videoRef = useRef(null);
  const isInView = useInView(ref, { margin: "-100px", triggerOnce: true });

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const scrollFactor = 0.5;
    const translateYValue = scrollY * scrollFactor;
    setTranslateY(-translateYValue);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_pep7bzo",
        "template_onp3cxh",
        formRef.current,
        "s0k4Giem9az3SkAKc"
      )
      .then(
        (result) => {
          setSuccess(true);
          alert("Form submitted successfully!");
        },
        (error) => {
          setError(true);
        }
      )
      .finally(() => {
        setIsButtonEnabled(false);
      });
  };

  return (
    <Container id="appointment">
      <Video
        ref={videoRef}
        src="./vid/starBg.mp4"
        autoPlay
        loop
        muted
        style={{ transform: `translateY(${translateY}px)` }}
        playsInline
      />
      <ContactContainer
        ref={ref}
        variants={variants}
        initial="initial"
        whileInView="animate"
      >
        <TextContainer variants={variants}>
          <motion.h1 variants={variants}>CONTACT US</motion.h1>
          <motion.div className="item" variants={variants}>
            <h2>Email</h2>
            <a href="mailto:info@luxedesign.com.my">info@luxedesign.com.my</a>
          </motion.div>
          <motion.div className="item" variants={variants}>
            <h2>Address</h2>
            <a
              href="https://ul.waze.com/ul?preview_venue_id=66650143.666370358.10926388&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
              target="_blank"
              rel="noopener noreferrer"
            >
              SO-02-01, Southbank Strata Office, Pusat Komersial Tebing Selatan,
              No.179, Jalan Kelang Lama, 58000 Kuala Lumpur, Malaysia
            </a>
          </motion.div>
          <motion.div className="item" variants={variants}>
            <h2>Phone</h2>
            <a href="tel:+60176300700">+6017-6300 700</a>
          </motion.div>
        </TextContainer>
        <FormContainer>
          <motion.div
            className="contactSvg"
            initial={{ opacity: 1 }}
            whileInView={{ opacity: 0 }}
            transition={{ delay: 1, duration: 1 }}
          >
            <ContactSvg
              width="450px"
              height="450px"
              viewBox="0 0 32.666 32.666"
            >
              <motion.path
                strokeWidth={0.2}
                fill="none"
                initial={{ pathLength: 0 }}
                animate={isInView && { pathLength: 5 }}
                transition={{ duration: 1 }}
              />
            </ContactSvg>
          </motion.div>
          <motion.form
            ref={formRef}
            onSubmit={sendEmail}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 1, duration: 1 }}
          >
            <input type="text" required placeholder="Name" name="name" />
            <FormRow>
              <input
                type="date"
                required
                placeholder="Date to make Appointment"
                name="date"
              />
              <input
                type="number"
                required
                placeholder="Phone Number"
                name="phone"
              />
            </FormRow>
            <FormRow>
              <input type="email" required placeholder="Email" name="email" />
              <select required name="service">
                <option value="" disabled selected>
                  Select Service
                </option>
                <option value="design">Design Only</option>
                <option value="design&build">Build & Design</option>
                <option value="build">Build Only</option>
              </select>
            </FormRow>
            <textarea rows={8} placeholder="Message" name="message" />
            <button
              disabled={!isButtonEnabled}
              style={{
                backgroundColor: !isButtonEnabled ? "grey" : "white",
                cursor: !isButtonEnabled ? "not-allowed" : "pointer",
              }}
            >
              Submit
            </button>
            {error && "Error"}
            {success && "Success"}
          </motion.form>
        </FormContainer>
      </ContactContainer>
    </Container>
  );
};

const Container = styled.div`
  scroll-snap-align: start;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  /* position: relative; */
  overflow: hidden;
  @media screen and (max-width: 768px) {
    height: 150vh;
  }
`;

const Video = styled.video`
  height: 100vh;
  width: 100vw;
  object-fit: cover;
  position: fixed;
  bottom: 0;
  z-index: -4;
`;

const variants = {
  initial: {
    y: 500,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      staggerChildren: 0.1,
    },
  },
};

const ContactContainer = styled(motion.div)`
  height: 100vh;
  width: 85%;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 300px;

  @media screen and (max-width: 768px) {
    width: 80%;
    gap: 50px;
    flex-direction: column;
  }
`;

const TextContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 40px;
  color: white;
  z-index: 20;

  @media screen and (max-width: 768px) {
    gap: 20px;
    text-align: center;
    align-items: center;
    /* margin-top: 70px; */
  }

  h1 {
    font-size: 70px;
    letter-spacing: 2px;
    margin-bottom: 20px;
    @media screen and (max-width: 768px) {
      width: 80%;
      font-size: 36px;
      margin-bottom: 0px;
      /* line-height: 88px; */
    }
  }

  a {
    font-weight: 300;
    color: white;
    text-decoration: none;
  }
`;

const FormContainer = styled.div`
  flex: 1;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 50px;
  }

  .contactSvg {
    stroke: none;
    fill: orange;
    position: absolute;
    margin: auto;
    z-index: -1;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;

    input,
    select,
    option,
    textarea {
      padding: 20px;
      background-color: transparent;
      border: 1px solid white;
      color: white;
      border-radius: 5px;

      @media screen and (max-width: 768px) {
        padding: 10px;
      }
    }
    select {
      background-color: black;
      @media screen and (max-width: 768px) {
        width: 80%;
      }
    }

    button {
      padding: 20px;
      border: none;
      font-weight: 500;
      border-radius: 5px;
      &:hover {
        opacity: 0.6;
      }
      @media screen and (max-width: 768px) {
        padding: 10px;
      }
    }
  }
`;

const FormRow = styled(motion.div)`
  flex-direction: row;
  display: flex;
  gap: 15px;
`;

export default Appointment;
